import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ApplicationPathConstants } from '@ddt-web/config';
import { CwpComponentResolver } from '@ddt-web/cwp';
import { MeAuthGuard, MeLocaleRouteGuard, MeRedirectGuard } from '@ddt-web/models-browsing';

const routes: Routes = [
	{
		path: ApplicationPathConstants.MODELS_EXPERIENCE_PATHS.HOME,
		pathMatch: 'full',
		loadChildren: () => import('./models-home/models-home.module').then(m => m.ModelsHomeModule),
		resolve: { cwpComponents: CwpComponentResolver },
		canActivate: [MeLocaleRouteGuard]
	},
	{
		path: ApplicationPathConstants.MODELS_EXPERIENCE_PATHS.FIND_AND_COMPARE,
		loadChildren: () => import('./find-compare/find-compare.module').then(m => m.FindCompareModule),
		resolve: { cwpComponents: CwpComponentResolver },
		canActivate: [MeRedirectGuard],
		data: { urlKey: 'FIND_AND_COMPARE_PAGE' }
	},
	{
		path: ApplicationPathConstants.MODELS_EXPERIENCE_PATHS.FAMILY,
		loadChildren: () => import('@ddt-web/models-browsing').then(mod => mod.FamilyDetailsContainerModule),
		canActivate: [MeAuthGuard, MeRedirectGuard],
		data: { urlKey: 'MODEL_FAMILY_DETAILS' }
	},
	{
		path: ApplicationPathConstants.MODELS_EXPERIENCE_PATHS.FUND_PERFORMANCE,
		loadChildren: () => import('@ddt-web/models-browsing').then(mod => mod.FundPerformanceFeesModule),
		canActivate: [MeAuthGuard, MeRedirectGuard],
		data: { urlKey: 'FUND_PERFORMANCE_AND_FEES' }
	},
	{
		path: ApplicationPathConstants.GENERATE_REPORT,
		loadChildren: () => import('@ddt-web/pdf-generate').then(m => m.PdfGenerateModule),
		canActivate: [MeAuthGuard]
	},

	// fallback
	{ path: '**', pathMatch: 'full', redirectTo: ApplicationPathConstants.MODELS_EXPERIENCE_PATHS.HOME }

];
@NgModule({
	imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, scrollPositionRestoration: 'disabled' })],
	exports: [RouterModule]
})
export class AppRoutingModule { }
